import { render } from "./DefaultValue.vue?vue&type=template&id=a66a2cfe"
import script from "./DefaultValue.vue?vue&type=script&lang=js"
export * from "./DefaultValue.vue?vue&type=script&lang=js"
script.render = render

export default script